__turbopack_context__.v({
  "image": "O5fp_W_image",
});
